var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { DOWNLOAD_BLUE_SVG, TRASH_BLUE_SVG, PAUSE_SMALL_WHITE_SVG, PLAY_SMALL_WHITE_SVG } from "../assets";
import Box from "./Box";
import { AddToHistory, PlayerState } from "../player/types";
import DynamicPlaylist from "../player/DynamicPlaylist";
import PlaybackManager from "../player/PlaybackManager";
import { Loader, ListView } from ".";
import { PlayerContextConsumer } from "../context/player";
import { displayDate } from "../util/date";
var CrateListView = /** @class */ (function (_super) {
    __extends(CrateListView, _super);
    function CrateListView(props) {
        var _this = _super.call(this, props) || this;
        _this.trackScrolling = function () {
            if (_this.container) {
                var wrappedElement = _this.container;
                if (_this.isBottom(wrappedElement)) {
                    _this.props.onEndReached && _this.props.onEndReached();
                }
            }
        };
        _this.state = {};
        _this.internallist = new DynamicPlaylist([], {
            history_mode: AddToHistory.ALL
        }, _this.props.context, false);
        _this.internallist.replace(_this.props.albums.map(function (album) {
            return {
                album: album,
                track: album.media[0],
                playbackInfo: album.media[0].stream_info,
                playlist: _this.internallist
            };
        }));
        return _this;
    }
    CrateListView.prototype.componentDidMount = function () {
        document.addEventListener('scroll', this.trackScrolling);
    };
    CrateListView.prototype.componentWillUnmount = function () {
        document.removeEventListener('scroll', this.trackScrolling);
    };
    CrateListView.prototype.componentDidUpdate = function (nextProps) {
        var _this = this;
        if (nextProps.albums != this.props.albums)
            this.internallist.replace(this.props.albums.map(function (album) {
                return {
                    album: album,
                    track: album.media[0],
                    playbackInfo: album.media[0].stream_info,
                    playlist: _this.internallist
                };
            }));
    };
    CrateListView.prototype.play = function (shuffle) {
        if (shuffle === void 0) { shuffle = false; }
        PlaybackManager.getInstance().getContentManager().replaceLists(this.internallist);
        PlaybackManager.getInstance().shuffle = shuffle;
        PlaybackManager.getInstance().startTrack(this.internallist.tracks()[0]);
    };
    CrateListView.prototype.onMediaSelected = function (media, album) {
        PlaybackManager.getInstance().getContentManager().replaceLists(this.internallist);
        PlaybackManager.getInstance().startTrack({
            album: album,
            track: media,
            playbackInfo: media.stream_info,
            playlist: this.internallist
        });
        this.props.onMediaSelected && this.props.onMediaSelected(media, album);
    };
    CrateListView.prototype.mouseLeavesRow = function (e) {
        e.currentTarget.classList.remove('active');
    };
    CrateListView.prototype.onPause = function () {
        PlaybackManager.getInstance().pause();
    };
    CrateListView.prototype.isMediaSelected = function (media, playerContext) {
        if (playerContext.track && playerContext.state >= PlayerState.Loading) {
            return playerContext.track.track.id == media.id;
        }
        return false;
    };
    CrateListView.prototype.renderTrackColumn = function (album) {
        return (React.createElement("div", { className: 'col-track' },
            React.createElement("div", { className: 'row-track' },
                React.createElement("div", { className: 'row-track-name' },
                    React.createElement("span", null, album.media[0].name)),
                React.createElement("div", { className: 'row-artist' }, ListView.renderArtistLink(album, this.props.onArtistClick)))));
    };
    CrateListView.prototype.renderCategoryColumn = function (album) {
        return React.createElement("div", { className: 'col-category' }, album.category.name);
    };
    CrateListView.prototype.renderCreatedAtColumn = function (album) {
        return React.createElement("div", { className: 'col-created_at' }, displayDate(album.added_to_crate || album.created_at));
    };
    CrateListView.prototype.renderBPMColumn = function (album) {
        return React.createElement("div", { className: 'col-bpm' }, album.bpm);
    };
    CrateListView.prototype.renderKeyColumn = function (album) {
        return React.createElement("div", { className: 'col-key' }, album.key || 'N/A');
    };
    CrateListView.prototype.renderMoreColumn = function (album) {
        var _this = this;
        return React.createElement("div", { className: 'col-more' },
            React.createElement("div", { className: 'actions' },
                !!(this.state.downloading && this.state.downloading == album.media[0].id) && React.createElement(Loader, { size: 20 }),
                !(this.state.downloading && this.state.downloading == album.media[0].id) &&
                    React.createElement("div", { className: 'hide-mobile', onClick: function (e) {
                            e.stopPropagation();
                            if (_this.props.onMediaDownlod) {
                                _this.setState({ downloading: album.media[0].id });
                                _this.props.onMediaDownlod(album.media[0], true, { target: e.currentTarget, desiredPosition: 'up' }).finally(function () {
                                    _this.setState({ downloading: undefined });
                                });
                            }
                        } },
                        React.createElement("img", { src: DOWNLOAD_BLUE_SVG, width: 20 })),
                !Boolean(this.props.hideDelete) &&
                    React.createElement("div", { onClick: function (e) {
                            e.stopPropagation();
                            if (_this.props.onRemoveFromCrate) {
                                _this.setState({ addingToCrate: album.media[0].id });
                                _this.props.onRemoveFromCrate(album.media[0]).finally(function () {
                                    _this.setState({ addingToCrate: undefined });
                                });
                            }
                        } },
                        React.createElement("img", { src: TRASH_BLUE_SVG, width: 15 }))));
    };
    CrateListView.prototype.renderSeperator = function (album, playerContext) {
        return React.createElement("div", { className: 'row-item-seperator' });
    };
    CrateListView.prototype.renderAudioItem = function (album, playerContext) {
        var _this = this;
        var mediaSelected = this.isMediaSelected(album.media[0], playerContext);
        return (React.createElement("div", { key: album.id + '' + album.media[0].id },
            React.createElement("div", { className: 'row-container ' + (mediaSelected ? 'active' : ''), onMouseLeave: this.mouseLeavesRow },
                React.createElement("div", { className: 'col-selected' }),
                React.createElement("div", { className: 'row-item row-item-album audio ' + (mediaSelected ? 'selected ' : ''), onClick: function () {
                        if (window.getSelection() && window.getSelection().toString().length > 0) {
                            return;
                        }
                        _this.onMediaSelected(album.media[0], album);
                    } },
                    React.createElement("div", { className: 'col-play' }, React.createElement("a", { href: "javascript:void(0)", onClick: function (e) {
                            if (playerContext.state >= PlayerState.Loading && mediaSelected) {
                                e.stopPropagation();
                                _this.onPause();
                            }
                        } },
                        !mediaSelected && React.createElement("div", { className: 'play' },
                            React.createElement("img", { src: PLAY_SMALL_WHITE_SVG, className: 'play white', width: ListView.DefaultPlayPauseSize })),
                        mediaSelected && React.createElement("div", { className: 'pause' },
                            React.createElement("img", { src: PAUSE_SMALL_WHITE_SVG, className: 'pause white', width: ListView.DefaultPlayPauseSize })))),
                    this.renderTrackColumn(album),
                    this.renderCategoryColumn(album),
                    this.renderCreatedAtColumn(album),
                    this.renderBPMColumn(album),
                    this.renderKeyColumn(album),
                    this.renderMoreColumn(album))),
            this.renderSeperator(album, playerContext)));
    };
    CrateListView.prototype.renderVideoItem = function (album, playerContext) {
        var _this = this;
        return this.renderAudioItem(album, playerContext);
        var mediaSelected = this.isMediaSelected(album.media[0], playerContext);
        return (React.createElement("div", { key: album.id + '' + album.media[0].id },
            React.createElement("div", { className: 'row-container ' + (mediaSelected ? 'active' : ''), onMouseLeave: this.mouseLeavesRow },
                React.createElement("div", { className: 'col-selected' }),
                React.createElement("div", { className: 'row-item  row-item-album video ' + (this.isMediaSelected(album.media[0], playerContext) ? 'selected ' : ''), onClick: function () { _this.onMediaSelected(album.media[0], album); } },
                    React.createElement("div", { className: 'col-play' }, React.createElement("a", { href: "javascript:void(0)", onClick: function (e) {
                            if (playerContext.state >= PlayerState.Loading && mediaSelected) {
                                e.stopPropagation();
                                _this.onPause();
                            }
                        } },
                        React.createElement("div", { className: mediaSelected ? 'pause' : 'play' },
                            album.image && React.createElement("img", { src: album.image, className: 'thumbnail' }),
                            React.createElement("div", { className: 'thumbnail-action' })))),
                    this.renderTrackColumn(album),
                    this.renderCategoryColumn(album),
                    this.renderCreatedAtColumn(album),
                    this.renderBPMColumn(album),
                    this.renderKeyColumn(album),
                    this.renderMoreColumn(album))),
            this.renderSeperator(album, playerContext)));
    };
    CrateListView.prototype.isBottom = function (el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    };
    CrateListView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: this.props.style, className: this.props.className },
            React.createElement(Box, { noPadding: true },
                React.createElement("div", { className: "crate-listview" },
                    React.createElement("div", { className: 'table-media', ref: function (ref) { return _this.container = ref; } }, this.props.albums.map(function (album, i) {
                        return (React.createElement(PlayerContextConsumer, { key: album.id + '_' + album.media[0].id }, function (value) {
                            return _this.renderAudioItem(album, value);
                        }));
                    }))))));
    };
    return CrateListView;
}(React.Component));
export default CrateListView;
//# sourceMappingURL=CrateListView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/CrateListView.js
// module id = 475
// module chunks = 0